import FilePreviewLink from "component/FilePreviewLink";
import { INotification } from "constant/interfaces";
import { Link } from "react-router-dom";
import { NotificationCategory } from "utils/notification";

interface IConveyedTableProps {
  notifications?: INotification[];
  baseNavigatePath?: string; // Optional prop to specify base path for navigation
}
const ConveyedTable = ({
  notifications,
  baseNavigatePath,
}: IConveyedTableProps) => {
  const renderText = (item: INotification, text: React.ReactNode) => {
    return <Link to={`${baseNavigatePath || ""}/${item.id}`}>{text}</Link>;
  };
  const renderTextByCategory = (item: INotification) => {
    let text = item.content; //"内容";
    if (item?.notification_category?.id === NotificationCategory.NearMiss) {
      text = item.occurrence_status; // `発生状況`;
    } else if (
      item?.notification_category?.id === NotificationCategory.IncidentReport
    ) {
      text = item.incident_detail; //`事故状況`;
    }
    return renderText(item, <p className="whitespace-pre-wrap">{text}</p>);
  };

  return (
    <div>
      {notifications?.map((item: INotification) => {
        return (
          <div
            className="flex max-lg:flex-col md:border-t border-b border-solid border-[#00000026] px-[15px] py-[8px] "
            key={item?.id}
          >
            <div className="px-2  min-w-[136px] max-md:w-full  ">
              {renderText(item, item?.created_at)}
            </div>
            <div className="px-2 w-[206px] max-md:w-full max-md:ml-[-7px]">
              {renderText(item, `【${item?.notification_category?.name}】`)}
            </div>
            <div className="px-2 flex-1 min-w-[200px] max-md:w-full ">
              {renderTextByCategory(item)}
            </div>
            <div className="px-2  min-w-[150px] max-md:w-full ">
              {renderText(item, `${item?.poster}`)}
            </div>
            <div className="px-2 flex-1 min-w-[150px] overflow-hidden max-md:w-full ">
              {item?.file_url?.image_path && (
                <FilePreviewLink file={item?.file_url?.image_path} />
              )}
            </div>
            <div className="px-2 w-[50px] max-md:w-full ">
              {renderText(item, ` 人${item?.view_count || 0}`)}
            </div>
          </div>
        );
      })}
    </div>
  );
};
export default ConveyedTable;
